import { render, staticRenderFns } from "./tabContent.vue?vue&type=template&id=d559f408&scoped=true"
import script from "./tabContent.vue?vue&type=script&lang=js"
export * from "./tabContent.vue?vue&type=script&lang=js"
import style0 from "./tabContent.vue?vue&type=style&index=0&id=d559f408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d559f408",
  null
  
)

export default component.exports